export default __webpack_public_path__ + "static/media/NF.b4054931.svg";